import type { Order } from '../../../types/apiResponse/order';

// Apenas valores monetários: quantidades, pesos e percentuais têm regras próprias.
export const orderMoneyColumns = new Set<keyof Order>([
  'returned_value', 'billed_value', 'ValorLiquido', 'ValorBruto', 'ValorComissao', 'aprov_pedmin_vlr',
  'valor_margem_comissao', 'valor_do_frete', 'valor_de_descarga',
]);

export function orderDecimalPlaces(value: unknown): number {
  const decimals = Number(String(value ?? '').trim().replace(',', '.'));
  return Number.isInteger(decimals) && decimals >= 1 && decimals <= 20 ? decimals : 2;
}

// Mesma regra do Sales: mais próximo, com empate em direção a +Infinity.
export function roundOrderMoney(value: number, decimals: number): number {
  const shift = (amount: number, places: number) => {
    const [coefficient, exponent = '0'] = String(amount).split('e');
    return Number(`${coefficient}e${Number(exponent) + places}`);
  };
  const shifted = shift(value, decimals);
  return Number.isFinite(shifted) ? shift(Math.round(shifted), -decimals) : value;
}

export function formatOrderMoney(value: unknown, decimals: number, locale: string, fallback = '—'): string {
  if (value == null || String(value).trim() === '') return fallback;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  const places = orderDecimalPlaces(decimals);
  return new Intl.NumberFormat(locale, {
    style: 'currency', currency: 'BRL',
    minimumFractionDigits: places, maximumFractionDigits: places,
  }).format(roundOrderMoney(parsed, places));
}
